import {
  drawerWidth,
  transition,
} from "assets/jss/material-dashboard-react.js";

const primaryBlue = "#2f72f2";
const sidebarBlue = "#2f72f2";
const navTextColor = "rgba(255,255,255,0.82)";
const activeBlue = "#ffffff";

const sidebarStyle = (theme) => ({
  drawerPaper: {
    border: "none",
    position: "fixed",
    top: "18px",
    bottom: "18px",
    left: "18px",
    zIndex: "1030",
    width: drawerWidth,
    background: sidebarBlue,
    boxShadow: "0 24px 60px rgba(47, 114, 242, 0.28)",
    borderRadius: "18px",
    [theme.breakpoints.up("md")]: {
      width: drawerWidth,
      position: "fixed",
      height: "calc(100% - 36px)",
    },
    [theme.breakpoints.down("sm")]: {
      width: drawerWidth,
      position: "fixed",
      display: "block",
      top: "0",
      height: "100vh",
      right: "0",
      left: "auto",
      zIndex: "1032",
      visibility: "visible",
      overflowY: "visible",
      borderTop: "none",
      borderRadius: "0",
      textAlign: "left",
      paddingRight: "0px",
      paddingLeft: "0",
      transform: `translate3d(${drawerWidth}px, 0, 0)`,
      ...transition,
    },
  },
  drawerPaperRTL: {
    [theme.breakpoints.up("md")]: {
      left: "auto !important",
      right: "0 !important",
    },
    [theme.breakpoints.down("sm")]: {
      left: "0  !important",
      right: "auto !important",
    },
  },
  logo: {
    position: "relative",
    padding: "24px 20px 20px",
    zIndex: "4",
    display: "flex",
    alignItems: "center",
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: "0",
      height: "1px",
      left: "18px",
      right: "18px",
      backgroundColor: "rgba(255,255,255,0.18)",
    },
  },
  logoLink: {
    fontFamily: '"Inter", "Roboto", "Helvetica", sans-serif',
    fontWeight: "700",
    fontSize: "20px",
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    color: "#ffffff",
    letterSpacing: "0",
    "&:hover": {
      color: "#ffffff",
    },
  },
  logoLinkRTL: {
    textAlign: "right",
  },
  logoImage: {
    width: "36px",
    height: "36px",
    borderRadius: "12px",
    background: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "12px",
    flexShrink: 0,
    overflow: "hidden",
  },
  img: {
    width: "20px",
    height: "20px",
    objectFit: "contain",
    filter: "none",
    position: "static",
    verticalAlign: "middle",
    border: "0",
  },
  background: {
    position: "absolute",
    zIndex: "1",
    height: "100%",
    width: "100%",
    display: "block",
    top: "0",
    left: "0",
  },
  list: {
    marginTop: "14px",
    paddingLeft: "0",
    paddingTop: "0",
    paddingBottom: "0",
    marginBottom: "0",
    listStyle: "none",
    position: "unset",
  },
  item: {
    position: "relative",
    display: "block",
    textDecoration: "none",
    "&:hover,&:focus,&:visited,&": {
      color: navTextColor,
    },
  },
  itemLink: {
    width: "auto",
    transition: "all 200ms ease",
    margin: "6px 10px",
    borderRadius: "11px",
    position: "relative",
    display: "flex",
    alignItems: "center",
    padding: "11px 13px",
    backgroundColor: "transparent",
    cursor: "pointer",
    color: navTextColor,
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.14)",
      color: primaryBlue,
    },
  },
  itemIcon: {
    width: "18px",
    height: "18px",
    fontSize: "18px",
    lineHeight: "18px",
    float: "left",
    marginRight: "14px",
    textAlign: "center",
    verticalAlign: "middle",
    color: "rgba(255,255,255,0.72)",
    flexShrink: 0,
  },
  itemIconRTL: {
    marginRight: "3px",
    marginLeft: "15px",
    float: "right",
  },
  itemText: {
    fontFamily: '"Inter", "Roboto", sans-serif',
    fontWeight: "600",
    fontSize: "13px",
    color: navTextColor,
    margin: "0",
    lineHeight: "1.4",
  },
  itemTextRTL: {
    textAlign: "right",
  },
  whiteFont: {
    color: primaryBlue + " !important",
  },
  // Active states
  purple: {
    backgroundColor: activeBlue,
    borderLeft: "0",
    "& $itemIcon": { color: primaryBlue },
    "& $itemText": { color: primaryBlue, fontWeight: "600" },
    "&:hover": { backgroundColor: activeBlue },
  },
  blue: {
    backgroundColor: activeBlue,
    borderLeft: `3px solid ${primaryBlue}`,
    "& $itemIcon": { color: primaryBlue },
    "& $itemText": { color: primaryBlue, fontWeight: "600" },
    "&:hover": { backgroundColor: activeBlue },
  },
  green: {
    backgroundColor: activeBlue,
    borderLeft: `3px solid ${primaryBlue}`,
    "& $itemIcon": { color: primaryBlue },
    "& $itemText": { color: primaryBlue, fontWeight: "600" },
    "&:hover": { backgroundColor: activeBlue },
  },
  orange: {
    backgroundColor: activeBlue,
    borderLeft: `3px solid ${primaryBlue}`,
    "& $itemIcon": { color: primaryBlue },
    "& $itemText": { color: primaryBlue, fontWeight: "600" },
    "&:hover": { backgroundColor: activeBlue },
  },
  red: {
    backgroundColor: activeBlue,
    borderLeft: `3px solid ${primaryBlue}`,
    "& $itemIcon": { color: primaryBlue },
    "& $itemText": { color: primaryBlue, fontWeight: "600" },
    "&:hover": { backgroundColor: activeBlue },
  },
  sidebarWrapper: {
    position: "relative",
    height: "calc(100vh - 128px)",
    overflow: "auto",
    width: drawerWidth + "px",
    zIndex: "4",
    overflowScrolling: "touch",
    "&::-webkit-scrollbar": { width: "4px" },
    "&::-webkit-scrollbar-track": { background: "transparent" },
    "&::-webkit-scrollbar-thumb": {
      background: "#d0d5dd",
      borderRadius: "4px",
    },
  },
  activePro: {
    [theme.breakpoints.up("md")]: {
      position: "absolute",
      width: "100%",
      bottom: "13px",
    },
  },
});

export default sidebarStyle;
